import { TriggerGroupType } from 'src/app/form-template/form-template-model';

export interface OperationTrackerConfig {
  operationName: string;
  extractDataFrom: string; // dot notation e.g. data.value.asset
}

export interface SuggestionConfig {
  typeConfig: SuggestionTypeConfig;
  keyToDataPathReplacementMap?: { [key: string]: string };
  triggerGroups?: WorkflowTriggerGroup[];
}

export interface BasicSuggestionConfig {
  type: SuggestionType.basic;
  title: string;
  description: string;
}

export enum SuggestionType {
  basic = 'basic'
}
export type SuggestionTypeConfig = BasicSuggestionConfig;

export interface WorkflowTrigger {
  dataPath: string;
  typeConfig: ComparisonTypeConfig;
}

export interface WorkflowTriggerGroup {
  type: TriggerGroupType;
  triggers: WorkflowTrigger[];
}

export type ComparisonTypeConfig = NotEmptyComparisonConfig | IsNullOrEmptyComparisonConfig;

export enum ComparisonType {
  notEmpty = 'notEmpty',
  isNullOrEmpty = 'isNullOrEmpty'
}

export interface NotEmptyComparisonConfig {
  type: ComparisonType.notEmpty;
}

export interface IsNullOrEmptyComparisonConfig {
  type: ComparisonType.isNullOrEmpty;
}
